import React, { useRef, useState } from "react";
import Img_2 from "../../assets/auth/admindashboardimg2.png";
import Img_logo from "../../assets/auth/logo.png";
import Suceess_Username from "../../assets/auth/username-send.png";
import Close_Button from "../../assets/auth/close.png";
import Styles from "../../styles/admin/login.module.scss";
import { useNavigate } from "react-router-dom";
import { forgetAdminPasswordService } from "../../services";
import { adminRoutes } from "../../routers/AdminRouters";
import Swal from "sweetalert2";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const usernameRef = useRef();
  const [buttonText, setButtonText] = useState("SUBMIT");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (usernameRef.current.value) {
      const success = await forgetAdminPasswordService(
        usernameRef.current.value
      );

      if (success) {
        setButtonText("RESEND");
        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 20px; position: relative;">
             <button 
                id="customCloseButton" 
                style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
                <img 
                src=${Close_Button} 
                  alt="Close" 
                  style="width: 50px; height: 50px;"
                />
              </button>
              <img 
                src=${Suceess_Username} 
                alt="Success" 
                style="width: 100px; margin-bottom: 20px;margin-top:30px;" 
              />
             
              <h2 style="font-family: 'gothambold';">Username Sent!</h2><br/>
              <p style="font-family: 'Gotham Book';">
                Username has been sent to 
                <span style="color: #F79328; font-family: 'Gotham Book';">
                  ${usernameRef.current.value}
                </span> 
                with instructions on resetting your password.
              </p>
              <button 
                id="thanksButton" 
                style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-family: 'gothambold'; border: none; border-radius: 5px; cursor: pointer; margin-top: 20px;">
                Thanks
              </button>
            </div>
          `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const thanksButton = document.getElementById("thanksButton");
            const closeButton = document.getElementById("customCloseButton");

            thanksButton.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.forgetPassword);
            });

            closeButton.addEventListener("click", () => {
              Swal.close();
            });
          },
        });
      }
    } else {
      Swal.fire({
        title: "Error",
        text: "Please enter a valid username address.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className={Styles.dashboard_main}>
      <div className={Styles.dashboard_flexmain}>
        <div className={Styles.flexdivider_1}>
          <img src={Img_2} alt="admin_dash_img1" />
        </div>
        <div className={Styles.flexdivider_2}>
          <div className={Styles.flexdivider_2_logo}>
            <img src={Img_logo} alt="admin_dash_logo" />
          </div>

          <div className={Styles.flexdivider_2_formcontainer}>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.label}>Username</label>
                <input
                  placeholder="Enter here"
                  type="username"
                  name="username"
                  minLength={2}
                  maxLength={50}
                  ref={usernameRef}
                  required
                />
              </div>
              <div className={Styles.flexdivider_2_formcontainer_link}>
                <a href="/login">Login</a>
              </div>
              <div className={Styles.flexdivider_2_formcontainer_button}>
                <button type="submit">
                  {" "}
                  <span>{buttonText}</span>{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
